var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIntroduction(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.5 19.5C28.5 20.3937 29.2125 21.125 30.0833 21.125H33.25C34.1208 21.125 34.8333 20.3937 34.8333 19.5C34.8333 18.6062 34.1208 17.875 33.25 17.875H30.0833C29.2125 17.875 28.5 18.6062 28.5 19.5Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2681 27.3318C25.7456 28.0468 25.8881 29.0381 26.5848 29.5581C27.4239 30.1918 28.3106 30.8743 29.1498 31.5243C29.8464 32.0606 30.8281 31.9143 31.3348 31.1993C31.3348 31.1831 31.3506 31.1831 31.3506 31.1668C31.8731 30.4518 31.7306 29.4443 31.0339 28.9243C30.1948 28.2743 29.3081 27.5918 28.4848 26.9581C27.7881 26.4218 26.8064 26.5843 26.2839 27.2993C26.2839 27.3156 26.2681 27.3318 26.2681 27.3318Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.366 7.81553C31.366 7.79928 31.3501 7.79928 31.3501 7.78303C30.8276 7.06803 29.846 6.92178 29.1651 7.45803C28.326 8.10803 27.4235 8.79053 26.6001 9.44053C25.9035 9.97678 25.7768 10.9843 26.2993 11.683C26.2993 11.6993 26.3151 11.6993 26.3151 11.7155C26.8376 12.4305 27.8035 12.5768 28.5001 12.0405C29.3393 11.4068 30.226 10.708 31.0651 10.058C31.746 9.53803 31.8726 8.53053 31.366 7.81553Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.668 14.625H6.33464C4.59297 14.625 3.16797 16.0875 3.16797 17.875V21.125C3.16797 22.9125 4.59297 24.375 6.33464 24.375H7.91797V29.25C7.91797 30.1438 8.63047 30.875 9.5013 30.875C10.3721 30.875 11.0846 30.1438 11.0846 29.25V24.375H12.668L20.5846 29.25V9.75L12.668 14.625Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.541 19.4994C24.541 17.3382 23.6227 15.3882 22.166 14.0557V24.9269C23.6227 23.6107 24.541 21.6607 24.541 19.4994Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntroduction);
export default __webpack_public_path__ + "static/media/introduction.4f68a554a525bb51604021ccda91587f.svg";
export { ForwardRef as ReactComponent };